import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

const ScrollableItem = (props: React.PropsWithChildren) => {
  const { children } = props

  return (
    <Box
      style={{
        borderBottom: '1px solid #E5E7EB', // grey400 equivalent
      }}
    >
      {children}
    </Box>
  )
}

export default ScrollableItem
